import getWrappedUseMutation from "api/helpers/getWrappedUseMutation";

import apiClient from "../../../api-client";

export const useCopySetupMutation = getWrappedUseMutation(apiClient.ItineraryBooklets.copySettings.put);
